import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'PaymentAllocation',
    column_type: 'id',
  },
  created_at: {
    model_name: 'PaymentAllocation',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'PaymentAllocation',
    column_type: 'datetime',
  },
  payment: {
    model_name: 'PaymentAllocation',
    column_type: 'belongs_to',
    extra: {
      association_name: 'payment',
      model_name: 'Payment',
    },
  },
  payment_id: {
    model_name: 'PaymentAllocation',
    column_type: 'belongs_to',
    extra: {
      association_name: 'payment',
      model_name: 'Payment',
    },
  },
  payable: {
    model_name: 'PaymentAllocation',
    column_type: 'belongs_to',
    extra: {
      association_name: 'payable',
      model_name: '',
    },
  },
  payable_id: {
    model_name: 'PaymentAllocation',
    column_type: 'belongs_to',
    extra: {
      association_name: 'payable',
      model_name: '',
    },
  },
  payable_type: {
    model_name: 'PaymentAllocation',
    column_type: 'string',
  },
  amount: {
    model_name: 'PaymentAllocation',
    column_type: 'decimal',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
